import PropTypes from 'prop-types';

export const formikOnChangeAdaptorTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
